module.exports = __webpack_public_path__ + "img/XPZ_Android.7f74f289.png";